const reasons = [
    "Moved validation card to 'Data Entry - In Progress' by accident",
    "Moved validation card to 'Ready for Validation' by accident",
    "Moved validation card to 'Validated and Submitted' by accident",
    "Need to change inputted data"
];

export default reasons;


// WEBPACK FOOTER //
// ./src/constants/ReasonForStatusChange.js